import { NgModule } from '@angular/core';
import { ItemInArrayPipe } from './item-in-array.pipe';

@NgModule({
  declarations: [ItemInArrayPipe],
  exports: [ItemInArrayPipe],
})
export class ItemInArrayModule {}
